import React from 'react';
import { bool } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveConnectModal } from '../../ducks/connectFlow';
import useUserConnections from '../../hooks/useUserConnections';
import styles from './styles/styles.module.scss';
import ActionCardInviteList from '../lists/ActionCardInviteList';
import ActionCardFindFriendsList from '../lists/ActionCardFindFriendsList';
import FacebookActionCard from '../cards/actionCards/FacebookActionCard';
import CommunityUserConnectionSearch from '../CommunityUserConnectionSearch';
import ActionCardFollowRequestList from '../lists/ActionCardFollowRequestList';
import { INVITE_FRIENDS_MODAL, FIND_FRIENDS_MODAL, FACEBOOK_NOT_SUBMITTED } from '../../constants';
import { StringConstantsMixin } from '../../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const {
  strings: {
    COMMUNITY: {
      CONNECT: { FRIENDS_ON_ALLTRAILS, INVITE_TO_ALLTRAILS, CONNECT, FOLLOWER_REQUESTS }
    }
  }
} = StringConstantsMixin;

const TRUNCATE_LIMIT = 8;

const ConnectDashboard = ({ showHeader }) => {
  const dispatch = useDispatch();
  const {
    followerRequests: { followerRequests },
    belay: {
      facebook: { facebookStatus }
    }
  } = useSelector(state => state);
  const findFriendsUserConnections = useUserConnections('findFriends');

  return (
    <div className={styles.container}>
      {showHeader && <h2 className={styles.header}>{CONNECT}</h2>}
      <CommunityUserConnectionSearch />
      {facebookStatus === FACEBOOK_NOT_SUBMITTED && <FacebookActionCard />}
      {followerRequests.length > 0 && (
        <ActionCardFollowRequestList header={FOLLOWER_REQUESTS} followerRequests={followerRequests} className={styles.listSpacer} />
      )}
      {findFriendsUserConnections.length > 0 && (
        <ActionCardFindFriendsList
          userConnections={findFriendsUserConnections}
          header={FRIENDS_ON_ALLTRAILS}
          truncateLimit={TRUNCATE_LIMIT}
          className={styles.listSpacer}
          handleViewAllClick={() => dispatch(setActiveConnectModal(FIND_FRIENDS_MODAL))}
        />
      )}
      <ActionCardInviteList
        header={INVITE_TO_ALLTRAILS}
        truncateLimit={TRUNCATE_LIMIT}
        className={styles.listSpacer}
        handleViewAllClick={() => dispatch(setActiveConnectModal(INVITE_FRIENDS_MODAL))}
      />
    </div>
  );
};

ConnectDashboard.propTypes = {
  showHeader: bool
};

ConnectDashboard.defaultProps = {
  showHeader: false
};

export default ConnectDashboard;
